import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksSalesInvoiceShippingDetails', {
    sectionTitle: 'Shipping details',
    shippingToFieldTitle: 'Shipping to',
    shipViaFieldTitle: 'Ship via',
    shippingDateFieldTitle: 'Shipping date',
    trackingNumberFieldTitle: 'Tracking number',
    shippingFromFieldTitle: 'Shipping from',
});
